import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '06',
  label: 'Років досвіду'
}, {
  value: '1000+',
  label: 'Успішних справ'
}, {
  value: '100%',
  label: 'Конфіденційність'
}];
export function Stats() {
  return <section className="border-b-2 border-black bg-white" data-id="element-97">
      <div className="max-w-[1400px] mx-auto" data-id="element-98">
        <div className="grid grid-cols-1 md:grid-cols-3 divide-y-2 md:divide-y-0 md:divide-x-2 divide-black" data-id="element-99">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="p-8 lg:p-12 flex flex-col justify-center items-center text-center" data-id="element-100">
              <h3 className="text-6xl lg:text-8xl font-bold mb-2" data-id="element-101">
                {stat.value}
              </h3>
              <p className="text-sm font-bold uppercase tracking-widest" data-id="element-102">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}